var map = {
	"./": 91091,
	"./SwapAuth": 42706,
	"./SwapAuth.ts": 42706,
	"./arbeth": 65965,
	"./arbeth.ts": 65965,
	"./bnb": 70637,
	"./bnb.ts": 70637,
	"./btc": 85864,
	"./btc.ts": 85864,
	"./eth": 61156,
	"./eth.ts": 61156,
	"./ghost": 80276,
	"./ghost.ts": 80276,
	"./index": 91091,
	"./index.ts": 91091,
	"./matic": 67749,
	"./matic.ts": 67749,
	"./next": 46818,
	"./next.ts": 46818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;